export type DeviceMotionData = Pick<DeviceMotionEvent, | 'accelerationIncludingGravity' | 'acceleration'>

export class SensorService {
  private deviceMotionData: DeviceMotionData | null = null


  constructor() {
    // This only works if the permission is already granted, otherwise the initSensorData() method must be called following a user action
    this.initSensorData()

    setInterval(() => {
      const stringify = (input: DeviceMotionEventAcceleration | null | undefined): string | null => {
        if (!input) return null
        return JSON.stringify({
          x: input.x?.toFixed(2),
          y: input.y?.toFixed(2),
          z: input.z?.toFixed(2)
        }, null, 2)
      }

      const debugElement = document.getElementById('debug')!
      //debugElement.innerText = `acc: ${ stringify(this.deviceMotionData?.acceleration) }\nacc+g: ${ stringify(this.deviceMotionData?.accelerationIncludingGravity) }`
    }, 500)
  }


  public async initSensorData(): Promise<boolean> {
    if (typeof (DeviceMotionEvent as any).requestPermission === 'function') {
      const permissionResponse = await (DeviceMotionEvent as any).requestPermission()
      if (permissionResponse === 'granted') {
        window.addEventListener('devicemotion', ({ acceleration, accelerationIncludingGravity }) => {
          this.deviceMotionData = { acceleration, accelerationIncludingGravity }
        })
        return true
      } else {
        return false
      }
    } else {
      console.log('No Device motion functionality detected')
      return false
    }
  }

  public getSensorData(): DeviceMotionData | null {
    return this.deviceMotionData
  }
}